import { render, staticRenderFns } from "./admin-user-edit-permissions-modal.vue?vue&type=template&id=09bea1d1&"
import script from "./admin-user-edit-permissions-modal.vue?vue&type=script&lang=ts&"
export * from "./admin-user-edit-permissions-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports